import { render, staticRenderFns } from "./assignee_avatar_link.vue?vue&type=template&id=34b8869b&"
import script from "./assignee_avatar_link.vue?vue&type=script&lang=js&"
export * from "./assignee_avatar_link.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports